// extracted by mini-css-extract-plugin
module.exports = {"Loading":"AdminApp_Loading__29bHT","LoadingSpin":"AdminApp_LoadingSpin__3R_Sd","Page":"AdminApp_Page__eQcjW","PageContent":"AdminApp_PageContent__2q0OG"};